import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '@app/_services';
import { environment } from '@environments/environment';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { DEVICE_REQUEST_CONTEXT } from '@app/_services/device.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService,
        private toastr: ToastrService,
        private router: Router) { }

        intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
            if (request.context.get(DEVICE_REQUEST_CONTEXT)) {
                return next.handle(request);
            }
            return next.handle(request).pipe(catchError(err => {
                if ([401, 403].includes(err.status)) {
                    // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
                    this.authenticationService.logout();
                }

                const error = err.error.message || err.statusText;
                return throwError(error);
            }))
        }

    // intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //     return next.handle(request).pipe(catchError(err => {
    //         if (err.status === 401) {
    //             // auto logout if 401 response returned from api
    //             //this.authenticationService.logout();
    //             // Attempt to use refresh token
    //             if (!environment.production) {
    //                 console.log('Using refresh token');
    //             }
    //             this.authenticationService.refresh().subscribe(
    //                 data => {
    //                       if (data.access_token) {
    //                         if (!environment.production) {
    //                             console.log('Session refresh successful');
    //                         }
    //                         //this.toastr.success('Session refresh successful.','Success');
    //                         location.reload();
    //                     } else {
    //                         this.toastr.error('Failed to refresh session', 'Error');
    //                         this.authenticationService.logout();
    //                         this.router.navigate(['/']);
    //                         //location.reload();

    //                     }


    //                 },
    //                 error => {
    //                     this.toastr.error('Session refresh failed.', 'Failed');
    //                     if (!environment.production) {
    //                         console.log('Failure Payload: ',error);
    //                     }
    //                     this.authenticationService.logout();
    //                     this.router.navigate(['/']);
    //                     //location.reload();
    //                 }
    //             );

    //             //location.reload();
    //             //location.reload(true);

    //         }

    //         if (err.status === 403) {
    //             this.toastr.error(err.error.message, 'Error');
    //             this.router.navigate(['/']);
    //         }
    //         const error = err.error.message || err.statusText;
    //         return throwError(error);
    //     }));
    // }
}
